import {
  UPDATE_QUESTION,
  UPDATE_QUESTION_SUCCESS,
  UPDATE_QUESTION_FAILURE,
} from 'store/updateQuestion/updateQuestionAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateQuestionReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_QUESTION:
      return { ...state, loading: true };
    case UPDATE_QUESTION_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_QUESTION_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateQuestionReducer;
